import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var DownloadIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13.972c0,-0.537 -0.435,-0.972 -0.972,-0.972c-2.252,0 -7.804,0 -10.056,0c-0.537,0 -0.972,0.435 -0.972,0.972c0,0.019 0,0.037 0,0.056c0,0.537 0.435,0.972 0.972,0.972c2.252,0 7.804,0 10.056,0c0.537,0 0.972,-0.435 0.972,-0.972c0,-0.019 0,-0.037 0,-0.056Z M8,8l0,-4.017c0,-0.261 0.104,-0.511 0.288,-0.695c0.184,-0.184 0.434,-0.288 0.695,-0.288c0.011,0 0.023,0 0.034,0c0.261,0 0.511,0.104 0.695,0.288c0.184,0.184 0.288,0.434 0.288,0.695l0,4.017l3.243,0l-4.243,4.243l-4.243,-4.243l3.243,0Z"
  }));
});
DownloadIcon.displayName = 'DownloadIcon';
export default DownloadIcon;